/**
 * @generated SignedSource<<73b6503a671deb0cc49925897c6c815a>>
 * @relayHash 1ae66697e924bcdf8583efca99854fee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f5e3a6046aa1ea7299d6f7de0855d16659140097a8d1c8fac6692062e222ac4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldSchemesAppQuery$variables = {
  cloudId: string;
};
export type FieldSchemesAppQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FieldSchemesPage">;
};
export type FieldSchemesAppQuery = {
  response: FieldSchemesAppQuery$data;
  variables: FieldSchemesAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FieldSchemesAppQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "FieldSchemesPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FieldSchemesAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraFieldSchemesConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemes",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "schemeId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldsCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectsCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isDefault"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isHighlighted"
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              },
              (v2/*: any*/)
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "fieldSchemesTable_adminPagesFieldSchemes_jira_fieldSchemes",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemes"
      }
    ]
  },
  "params": {
    "id": "8f5e3a6046aa1ea7299d6f7de0855d16659140097a8d1c8fac6692062e222ac4",
    "metadata": {},
    "name": "FieldSchemesAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d849fa3dc746f78acf5e0a8b2791820";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
